<template>
  <div class="LessonEntityDetails__Component">
    <FieldInlineText type="number" label="מזהה חיצוני" @onChange="onChange" v-model="model.externalId" />
    <FieldInlineDateTime label="זמן התחלת ההרצאה" @onChange="onChange" :hide-hover="true" position="is-bottom-left"
      v-model="model.startTime" />
    <FieldInlineDateTime label="זמן סיום ההרצאה" @onChange="onChange" :hide-hover="true" position="is-bottom-left"
      v-model="model.endTime" />

    <FieldInlineSelect label="מרצה" @onChange="onChange" :filterable="true" :clearable="true"
      :optionsAsync="getTeachers" v-model="model.lecturesTeachersId" />

    <FieldInlineSelect label="אולם" @onChange="onChange" :filterable="true" :clearable="true" :optionsAsync="getHalls"
      v-model="model.lecturesHallsId" />

    <FieldInlineText type="number" label="קיבולת" @onChange="onChange" v-model="model.capacity" />

    <FieldInlineText type="number" label="קו צהוב" @onChange="onChange" v-model="model.capacityYellowLine" />

    <FieldInlineText label="הערה לתלמיד" @onChange="onChange" v-model="model.userNote" />

    <FieldInlineText label="הערה פנימית" @onChange="onChange" v-model="model.editorNote" />

    
    <!-- <ckeditor :editor="editor" placeholder="'הנחיות'" @input="onChange" v-model="model.instractionsNote" :config="editorConfig">
    </ckeditor> -->
    <NewActivityEditor @onEditorChange="onEditorChange" :ckEditorContent="model.instractionsNote" :content="model.instractionsNote" ref="editor" />
    
    <b-checkbox style="margin-top: 10px;" @input="onChange" v-model="model.isWebinarRegistrationRequired">
     נדרשת הרשמה לוובינר
    </b-checkbox>
    
    <FieldInlineText type="number" label="מזהה לוובינר" @onChange="onChange" v-model="model.webinarId" />

    <FieldInlineText :readOnly="model.isWebinarRegistrationRequired" label="קישור לוובינר" @onChange="onChange" v-model="model.webinarUrl" />

    <div class="checkbox-container">
      <b-switch class="ltr" @input="onChange" v-model="model.status">{{
      model.status ? "פעיל" : "לא פעיל"
        }}</b-switch>
    </div>

  </div>
</template>

<script>
import FieldInlineText from '@/components/Fields/FieldInlineText.vue';
// import FieldInlineTextArea from '@/components/Fields/FieldInlineTextArea.vue';
// import FieldInlineDate from '@/components/Fields/FieldInlineDate.vue';
import FieldInlineDateTime from '@/components/Fields/FieldInlineDateTime.vue';
import FieldInlineSelect from '@/components/Fields/FieldInlineSelect.vue';
import CoursesService from '@/services/CoursesService';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { mapGetters, mapMutations } from 'vuex';
import vSelect from "vue-select";
import "vue-select/src/scss/vue-select.scss";
import NewActivityEditor from './NewActivityEditor.vue';

const {
    ClassicEditor,
    Alignment,
    // Autoformat, // Disabled to fix asterisk auto-formatting
    Base64UploadAdapter,
    AutoImage,
    AutoLink,
    Autosave,
    BalloonToolbar,
    BlockQuote,
    Bold,
    Bookmark,
    CloudServices,
    Code,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    Highlight,
    HorizontalLine,
    HtmlComment,
    HtmlEmbed,
    ImageBlock,
    ImageCaption,
    ImageInline,
    ImageInsertViaUrl,
    ImageResize,
    ImageStyle,
    ImageTextAlternative,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    //
    MediaEmbed,
    Paragraph,
    PasteFromMarkdownExperimental,
    PasteFromOffice,
    RemoveFormat,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    Strikethrough,
    Style,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextTransformation,
    TodoList,
    Underline,
    FindAndReplace,
    PageBreak,
    ShowBlocks,
    WordCount
} = CKEDITOR;

const { ExportPdf, ExportWord, LineHeight } = CKEDITOR_PREMIUM_FEATURES;

export default {
  name: 'LessonEntityDetails',
  components: {
    FieldInlineText,
    FieldInlineSelect,
    FieldInlineDateTime,
    vSelect,
    NewActivityEditor
  },
  props: ['readOnly'],
  data() {
    return {
      model: {
        address: null,
        capacity: null,
        capacityYellowLine: null,
        count: null,
        createdUserId: null,
        dateCreated: null,
        day: null,
        editorNote: null,
        endTime: null,
        hallName: null,
        id: null,
        externalId: null,
        instractionsNote: null,
        lecturesHallsId: null,
        lecturesLearningTrackSubjectsId: null,
        lecturesTeachersId: null,
        startTime: null,
        status: null,
        subjectName: null,
        teacherName: null,
        trackName: null,
        userNote: null,
        isWebinarRegistrationRequired: null,
        webinarId: null,
        webinarUrl: null
      },
      editor: ClassicEditor,
      editorConfig: {
                language: 'he',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'fontSize',
                        'fontFamily',
                        'fontColor',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        'caseChange',
                        'formatPainter',
                        '|',
                        'link',
                        'insertTable',
                        'highlight',
                        'pageBreak',
                        '|',
                        'alignment',
                        '|',
                        'bulletedList',
                        'numberedList',
                        'todoList',
                        'multilevelList',
                        'outdent',
                        'indent',
                        '|',
                        'findAndReplace',
                        'tableOfContents',
                        'showBlocks',
                        '|',
                        'exportPdf',
                        'exportWord'
                    ],
                    shouldNotGroupWhenFull: false
                },
                plugins: [
                    Alignment,
                    // Autoformat, // Disabled to fix asterisk auto-formatting
                    Base64UploadAdapter,
                    AutoImage,
                    AutoLink,
                    Autosave,
                    BalloonToolbar,
                    BlockQuote,
                    Bold,
                    Bookmark,
                    CloudServices,
                    Code,
                    Essentials,
                    FontBackgroundColor,
                    FontColor,
                    FontFamily,
                    FontSize,
                    GeneralHtmlSupport,
                    Heading,
                    Highlight,
                    HorizontalLine,
                    HtmlComment,
                    HtmlEmbed,
                    ImageBlock,
                    ImageCaption,
                    ImageInline,
                    ImageInsertViaUrl,
                    ImageResize,
                    ImageStyle,
                    ImageTextAlternative,
                    ImageToolbar,
                    ImageUpload,
                    Indent,
                    IndentBlock,
                    Italic,
                    Link,
                    LinkImage,
                    List,
                    ListProperties,
                    //
                    MediaEmbed,
                    Paragraph,
                    PasteFromMarkdownExperimental,
                    PasteFromOffice,
                    RemoveFormat,
                    SpecialCharacters,
                    SpecialCharactersArrows,
                    SpecialCharactersCurrency,
                    SpecialCharactersEssentials,
                    SpecialCharactersLatin,
                    SpecialCharactersMathematical,
                    SpecialCharactersText,
                    Strikethrough,
                    Style,
                    Subscript,
                    Superscript,
                    Table,
                    TableCaption,
                    TableCellProperties,
                    TableColumnResize,
                    TableProperties,
                    TableToolbar,
                    TextTransformation,
                    TodoList,
                    Underline,
                    ExportPdf,
                    ExportWord,
                    LineHeight,
                    FindAndReplace,
                    PageBreak,
                    ShowBlocks,
                    WordCount,
                ].filter(Boolean),
                balloonToolbar: ['bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList'],
                fontFamily: {
                    supportAllValues: true
                },
                fontSize: {
                    options: [10, 12, 14, 'default', 18, 20, 22],
                    supportAllValues: true
                },
                lineHeight: {
                    options: ['default', 1, 1.1, 1.25, 1.5, 2, 2.5, 3]
                },
                heading: {
                    options: [
                        {
                            model: 'paragraph',
                            title: 'Paragraph',
                            class: 'ck-heading_paragraph'
                        },
                        {
                            model: 'heading1',
                            view: 'h1',
                            title: 'Heading 1',
                            class: 'ck-heading_heading1'
                        },
                        {
                            model: 'heading2',
                            view: 'h2',
                            title: 'Heading 2',
                            class: 'ck-heading_heading2'
                        },
                        {
                            model: 'heading3',
                            view: 'h3',
                            title: 'Heading 3',
                            class: 'ck-heading_heading3'
                        },
                        {
                            model: 'heading4',
                            view: 'h4',
                            title: 'Heading 4',
                            class: 'ck-heading_heading4'
                        },
                        {
                            model: 'heading5',
                            view: 'h5',
                            title: 'Heading 5',
                            class: 'ck-heading_heading5'
                        },
                        {
                            model: 'heading6',
                            view: 'h6',
                            title: 'Heading 6',
                            class: 'ck-heading_heading6'
                        }
                    ]
                },
                htmlSupport: {
                    allow: [
                        {
                            name: /^.*$/,
                            styles: true,
                            attributes: true,
                            classes: true
                        }
                    ]
                },
                image: {
                    toolbar: [
                        'toggleImageCaption',
                        'imageTextAlternative',
                        '|',
                        'imageStyle:inline',
                        'imageStyle:wrapText',
                        'imageStyle:breakText',
                        '|',
                        'resizeImage'
                    ]
                },
                licenseKey: process.env.VUE_APP_CKEDITOR_LICENSE_KEY,
                exportPdf: {
                    stylesheets: [
                        'https://cdn.ckeditor.com/ckeditor5/44.1.0/ckeditor5.css',
                        'https://cdn.ckeditor.com/ckeditor5-premium-features/44.1.0/ckeditor5-premium-features.css'
                    ],
                    fileName: 'document.pdf',
                    converterOptions: {
                        format: 'A4',
                        margin_top: '20mm',
                        margin_bottom: '20mm',
                        margin_right: '12mm',
                        margin_left: '12mm',
                        page_orientation: 'portrait'
                    }
                },
                exportWord: {
                    stylesheets: [
                        'https://cdn.ckeditor.com/ckeditor5/44.1.0/ckeditor5.css',
                        'https://cdn.ckeditor.com/ckeditor5-premium-features/44.1.0/ckeditor5-premium-features.css'
                    ],
                    fileName: 'document.docx',
                    converterOptions: {
                        format: 'A4',
                        margin_top: '20mm',
                        margin_bottom: '20mm',
                        margin_right: '12mm',
                        margin_left: '12mm',
                        orientation: 'portrait'
                    }
                },
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'https://',
                    decorators: {
                        toggleDownloadable: {
                            mode: 'manual',
                            label: 'Downloadable',
                            attributes: {
                                download: 'file'
                            }
                        }
                    }
                },
                list: {
                    properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true
                    }
                },
                menuBar: {
                    isVisible: true
                },
                placeholder: '',
                style: {
                    definitions: [
                        {
                            name: 'Article category',
                            element: 'h3',
                            classes: ['category']
                        },
                        {
                            name: 'Title',
                            element: 'h2',
                            classes: ['document-title']
                        },
                        {
                            name: 'Subtitle',
                            element: 'h3',
                            classes: ['document-subtitle']
                        },
                        {
                            name: 'Info box',
                            element: 'p',
                            classes: ['info-box']
                        },
                        {
                            name: 'Side quote',
                            element: 'blockquote',
                            classes: ['side-quote']
                        },
                        {
                            name: 'Marker',
                            element: 'span',
                            classes: ['marker']
                        },
                        {
                            name: 'Spoiler',
                            element: 'span',
                            classes: ['spoiler']
                        },
                        {
                            name: 'Code (dark)',
                            element: 'pre',
                            classes: ['fancy-code', 'fancy-code-dark']
                        },
                        {
                            name: 'Code (bright)',
                            element: 'pre',
                            classes: ['fancy-code', 'fancy-code-bright']
                        }
                    ]
                },
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
                }
            },
      regions: []
    };
  },
  computed: {
    ...mapGetters('lecture', [
      'form',
    ]),
    courseId() {
      return this.$store.state.auth?.course.id;
    },
    changesAmount() {
      return Object.keys(this.diff(this.model, this.form)).length;
    },
  },
  created() {
    this.model = { ...this.model, ...this.form };
  },
  methods: {
    diff(o1, o2) {
      const diff = Object.keys(o2).reduce((diff1, key) => {
        if (o1[key] && typeof o1[key].getMonth === 'function') {
          if (new Date(o1[key]).toString() === new Date(o2[key]).toString()) return diff1;
        }
        if (typeof o1[key] === 'number') {
          if (parseInt(o1[key], 10) === parseInt(o2[key], 10)) return diff1;
        }
        if (o1[key] && typeof o1[key] === 'object' && typeof o1[key].getMonth !== 'function') {
          if (o1[key]?.Id === o2[key]?.Id) return diff1;
        }
        if (o1[key] === o2[key]) return diff1;
        return {
          ...diff1,
          [key]: o2[key],
        };
      }, {});

      return diff;
    },
    onChange() {
      if (this.model.isWebinarRegistrationRequired) {
        this.model.webinarUrl = null;
      }
      this.$emit('onFormChange', this.changesAmount);
    },
    onEditorChange(value) {
      this.model.instractionsNote = value;
      this.$emit('onFormChange', this.changesAmount);
    },
    cancel() {
      this.model = { ...this.model, ...this.form };
    },
    save() {
      this.$emit('onFormSave', {
        model: this.model,
        cancel: this.cancel,
        setRestorePoint: this.setRestorePoint,
      });
    },
    getTeachers() {
      return () =>
        CoursesService.getCourseTeachers(this.courseId, {
          PageSize: 9999,
          IsAscending: false,
          PageNumber: 1,
          ResultType: 3
        }).then((r) =>
          r.data.items.map((i) => ({ Value: i.id, Text: i.fullName }))
        );
    },
    getHalls() {
      return () =>
        CoursesService.getCourseHalls(this.courseId, {
          PageSize: 9999,
          IsAscending: false,
          PageNumber: 1,
          ResultType: 3
        }).then((r) =>
          r.data.items.map((i) => ({ Value: i.id, Text: i.name }))
        );
    },
    setRestorePoint() {
      this.storeLessonDetails(this.model);
    },
    refresh() {
      this.model = { ...this.model, ...this.form };
    },
    ...mapMutations('lecture', [
      'storeLessonDetails',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.checkbox-container {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
</style>
